import React from "react"
import { Box, Typography, Paper } from "@mui/material"

// Componente simplificado para mostrar mapa usando iframe de Google Maps
const MapaUbicacion = ({ latitud, longitud, precision, isMobile }) => {
  const mapUrl = `https://maps.google.com/maps?q=${latitud},${longitud}&z=16&output=embed`

  return (
    <Paper sx={{ p: 2, mt: 2 }}>
      <Typography variant="subtitle1" gutterBottom sx={{ textAlign: "center" }}>
        Ubicación registrada:
      </Typography>

      <Box
        sx={{
          mt: 2,
          borderRadius: 2,
          overflow: "hidden",
          height: isMobile ? "250px" : "350px",
          boxShadow: 3,
        }}
      >
        <iframe
          title="Ubicación registrada"
          width="100%"
          height="100%"
          frameBorder="0"
          scrolling="no"
          marginHeight="0"
          marginWidth="0"
          src={mapUrl}
          style={{ border: 0 }}
          allowFullScreen=""
          aria-hidden="false"
          tabIndex="0"
        />
      </Box>

      <Typography variant="body2" sx={{ mt: 1, textAlign: "center", color: "text.secondary" }}>
        Precisión: ±{Math.round(precision)} metros
      </Typography>
    </Paper>
  )
}

export default MapaUbicacion
